import React from 'react';

export default function Footer() {
  return (
    <footer className="w-full bg-black text-gray-500 py-10 px-6 md:px-10 border-t border-gray-800">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">

        {/* Branding */}
        <div className="text-center md:text-left">
          <h4 className="text-white text-lg font-semibold">Million2Trillion (M2T)</h4>
          <p className="text-sm">© {new Date().getFullYear()} All rights reserved.</p>
        </div>

        {/* Footer Links */}
        <div className="flex flex-wrap justify-center gap-4 text-sm">
          <a href="/terms" className="hover:text-white">Terms</a>
          <a href="/privacy" className="hover:text-white">Privacy</a>
          <a href="mailto:support@million2trillion.com" className="hover:text-white">Contact</a>
        </div>

        {/* Social Icons (Optional) */}
        <div className="flex gap-4">
          <a href="https://twitter.com/million2trill" target="_blank" rel="noopener noreferrer" className="hover:text-white">
            X (Twitter)
          </a>
          <a href="https://facebook.com/million2trillion" target="_blank" rel="noopener noreferrer" className="hover:text-white">
            Facebook
          </a>
        </div>

      </div>
    </footer>
  );
}
